var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"customerContainer"}},[_c('p',[_vm._v("重要客户及合作单位")]),_c('div',{attrs:{"id":"customerWapper"}},[_c('div',{staticClass:"custImg",attrs:{"id":"custLeft"}}),_c('div',{attrs:{"id":"customerCont"}}),_c('div',{staticClass:"custImg",attrs:{"id":"custRight"}})])])
}]

export { render, staticRenderFns }